/* eslint-disable react/jsx-fragments */
import { Col, Flex, Image, MenuProps, message, notification, Row } from "antd";
import React, { forwardRef, useContext, useEffect, useMemo, useState } from "react";
import { saveToClipboard } from "../../../helpers";
import { SvgIcon } from "../../../shared/icons";
import { MeetingLinksContext } from "../../app/context/MeetingLinksContext";
import { CustomCard } from "../../ui/CustomCard";
import { EmptyState } from "../../ui/EmptyState";
import noData from "src/shared/images/noData.png";
import viewermodedis from "src/shared/images/viewermodedis.svg";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "src/store";
import { addCalBe, getSchedLinks } from "src/store/reactive-links-settings/asyncRequests";
import { reactiveLinksSelector, resetOutcome, setSelRoundRobinMeetId } from "src/store/reactive-links-settings";
import { Loader } from "src/components/ui";
import { fullUserSelector } from "src/store/user";

interface MeetingLinksProps {
  openEditMeetingLinkDrawer: (boolean) => void;
  isTourStep?: boolean;
  openDeleteMeetingLinkDrawer: () => void;
  openAiAssistantSettings: () => void;
  meetingLinksCardRef?: any;
  isTeam?: boolean;
  isTeamSearchUp?: boolean;
}

export const MeetingLinks = forwardRef<HTMLDivElement, MeetingLinksProps>((prop, ref) => {
  const { sdBarCollapsed } = useSelector(fullUserSelector);
  const { isTourStep, openEditMeetingLinkDrawer, openDeleteMeetingLinkDrawer, meetingLinksCardRef, openAiAssistantSettings, isTeam, isTeamSearchUp, disabled } =
    prop;
  const { meetingLinks, setSelectedMeetingLinkId } = useContext(MeetingLinksContext);
  const [tourStepData, setTourStepData] = useState(meetingLinks);
  const { teamLinks, teamLinksSearchedFor, teamLinksToSearchLoading, teamLinksToSearchId } = useSelector(reactiveLinksSelector);

  useEffect(() => {
    if (teamLinksToSearchId && teamLinksToSearchId !== "team" && teamLinksSearchedFor?.id !== teamLinksToSearchId) {
      // console.log(teamLinksToSearchId, "teamLinksToSearchId");
      dispatch(getSchedLinks({ teamLinksToSearchId }));
    }
  }, [teamLinksToSearchId]);

  console.log(teamLinks, "teamLinksteamLinks", teamLinksSearchedFor);
  const [teamRoundRobinMeetings, setTeamRoundRobinMeetings] = useState([]);
  const [sortedMeetingLinks, setSortedMeetingLinks] = useState([]);

  useEffect(() => {
    const srtdMeetingLinks =
      isTeam || (isTeamSearchUp && teamLinksToSearchId === "team")
        ? [...(teamRoundRobinMeetings || [])?.filter((mt) => isTeam || mt?.teamMembers?.length)]
        : isTeamSearchUp && teamLinksToSearchId
        ? isTeamSearchUp && teamLinksToSearchId === teamLinksSearchedFor?.id
          ? (teamLinksSearchedFor?.links?.length && [...teamLinksSearchedFor?.links]?.slice(1)) || []
          : []
        : [...meetingLinks].sort((a, b) => (a.isAiGenerated === b.isAiGenerated ? 0 : a.isAiGenerated ? -1 : 1));
    console.log(srtdMeetingLinks, "srtdMeetingLinks");

    setSortedMeetingLinks(srtdMeetingLinks);
  }, [meetingLinks, isTeam, teamRoundRobinMeetings, teamLinksToSearchId, teamLinksSearchedFor]);

  useEffect(() => {
    setTeamRoundRobinMeetings(teamLinks || []);
  }, [teamLinks]);

  // const { emailToAddN, setEmailToAddNow } = useContext(MeetingLinksContext)

  const dropdownMenuItems: MenuProps["items"] = [
    {
      key: "1",
      label: "Edit Meeting Link",
      onClick: () => openEditMeetingLinkDrawer(false),
    },
    (meetingLinks?.length > 2 || (meetingLinks?.length > 1 && isTeam)) && {
      key: "2",
      label: "Delete",
      onClick: () => openDeleteMeetingLinkDrawer(),
    },
  ]?.filter((val) => val);

  // DO NOT ALLOW DELETE OF AI!!
  const aiDropDownMenuItems: MenuProps["items"] = [
    {
      key: "1",
      label: "Edit Default Meeting",
      onClick: () => openEditMeetingLinkDrawer(true),
    },
    {
      key: "2",
      label: "Customize Ai Assistant",
      onClick: () => openAiAssistantSettings(),
    },
  ];

  // console.log(sortedMeetingLinks, "sortedMeetingLinks");

  // isTourStep ? (
  //   <Row gutter={[24, 24]}>
  //   {sortedMeetingLinks.map((card, index) => (
  //       <Col span={8} key={card.id}>
  //         <CustomCard
  //           ref={index === 0 ? meetingLinksCardRef : null}
  //           id={card.id}
  //           title={card.name}
  //           description={card.description}
  //           tags={card.tags}
  //           links={card.links}
  //           isOutlined={card.isAiGenerated}
  //           onDropdownClick={() => setSelectedMeetingLinkId(card.id)}
  //           onLinkClick={(href: string) => {
  //             saveToClipboard(href)
  //             notification.info({
  //               message: "Copied",
  //               description: false,
  //               duration: 5,
  //               icon: <SvgIcon type={"infoFilled"} />,
  //               closeIcon: false,
  //               placement: "bottomRight",
  //             })
  //           }}
  //           dropdownMenuItems={dropdownMenuItems}
  //         />
  //       </Col>
  //     ))}
  //   </Row>
  // ) :

  //  sortedMeetingLinks.length === 0 ? (
  //   <EmptyState text={"Loading..."} /> should always have at least 2 or there is an error.
  // ) :
  const dispatch = useDispatch();
  return (
    <>
      <Row
        gutter={[24, 24]}
        style={{
          width: isTeam ? (sdBarCollapsed ? "calc(100vw - 420px)" : "calc(100vw - 550px)") : "default",
          marginBottom: disabled ? "30px" : "default",
          marginLeft: disabled ? "20px" : "default",
          textAlign: disabled ? "center" : null,
        }}
      >
        {sortedMeetingLinks?.length && !disabled ? (
          sortedMeetingLinks.map((card, i) => {
            // if (!i) {
            //   console.log(card, "team_custom_url");
            // }
            const tags = [
              { text: `${card.meetingLength / 60000} min`, color: "Green", type: "Meeting Length" },
              !i && !isTeam && !isTeamSearchUp && { text: "AI", color: "Purple", type: "AI Generated" },
              isTeam && { text: `${card?.teamMembers?.length || 0} members`, color: "Purple", type: "AI Generated" },
              isTeam && {
                text: `${card?.teamMembers?.length ? "Active link" : "Inactive link"}`,
                color: card?.teamMembers?.length ? "Blue" : "Red",
                type: "AI Generated",
              },
            ]?.filter(Boolean);
            const title = card.name?.value || card.name || "";
            return (
              <Col span={8} key={card.id}>
                <CustomCard
                  canEdit={!isTeamSearchUp}
                  ref={i === 0 && !isTeam && !isTeamSearchUp ? meetingLinksCardRef : null}
                  id={card.id}
                  title={title?.length > 150 ? title?.substring(0, 150) + "..." : title}
                  description={card.description?.length > 200 ? card.description?.substring(0, 200) + "..." : card.description || ""}
                  tags={tags}
                  links={
                    !i && !isTeam && !isTeamSearchUp
                      ? card.links
                      : [
                          { href: `https://app.meetz.ai/cal/${card?.custom_url}`, text: `Copy${isTeam ? " your" : ""} link` },
                          !!card.team_custom_url && { href: `https://app.meetz.ai/cal/${card?.team_custom_url}`, text: "General link" },
                        ]?.filter(Boolean)
                  }
                  // team_custom_url
                  isOutlined={card.isAiGenerated}
                  onDropdownClick={() => (isTeam ? dispatch(setSelRoundRobinMeetId(card.id)) : setSelectedMeetingLinkId(card.id))}
                  onLinkClick={(href: string) => {
                    saveToClipboard(href);
                    notification.info({
                      message: !i && !isTeam && !isTeamSearchUp ? "Copied Email" : "Copied Link",
                      description: false,
                      duration: 5,
                      icon: <SvgIcon type={"infoFilled"} />,
                      closeIcon: false,
                      placement: "bottomRight",
                    });
                  }}
                  dropdownMenuItems={!i && !isTeam ? aiDropDownMenuItems : dropdownMenuItems}
                  isTeamMeeting={isTeam}
                  // isTeamSearchUp
                  //  // to not allow them to edit
                />
              </Col>
            );
          })
        ) : (
          <Flex
            style={{
              // this is only good for setting place
              width: sdBarCollapsed ? "calc(100vw - 420px)" : "calc(100vw - 550px)",
              flexDirection: "column",
              alignItems: "center",
              justifyItems: "center",
            }}
          >
            <br />
            <Image preview={false} src={disabled ? viewermodedis : noData} alt={"No data"} width={200} />
            <br />
            <Flex style={{ flexDirection: "column", alignItems: "center", justifyItems: "center", marginTop: "10px", height: "20px" }}>
              <div style={{ fontSize: "16px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                {disabled
                  ? `Your account is currently of type "Viewer", which allows you to manage the team and view activity, but not perform outreach or book meetings.`
                  : isTeam
                  ? `Admins can add round-robin links via the "Add round robin link" button above.`
                  : isTeamSearchUp
                  ? teamLinksToSearchLoading
                    ? `Loading...`
                    : `No meeting links found`
                  : "Add meeting link by clicking on the above."}
                {!!isTeamSearchUp && !!teamLinksToSearchLoading && <Loader style={{ marginLeft: "30px" }} />}
              </div>
            </Flex>
          </Flex>
        )}
      </Row>
    </>
  );
});
